import React from 'react';
import { Button } from 'react-bootstrap';

export function getSampleFiles(combination_id) {
  let files = [];
  let mimetype = 'image/png';
  let file1 = '';
  let file2 = '';

  if (combination_id === 8 || combination_id === 9) {
    // manual invoice data extraction
    file1 = `/samples/sample_invoice.png`;
    mimetype = 'image/png';
  } else if (combination_id === 10 || combination_id === 12) {
    // reconciliation
    file1 = '/samples/invoices_example.csv';
    file2 = '/samples/purchase_orders_example.csv';
    mimetype = 'text/csv';
  } else if (combination_id === 11) {
    // manual financial report
    file1 = '/samples/demo_company_financial_report.pdf';
    mimetype = 'application/pdf';
  }

  if (file1) {
    files.push(
      fetch(file1)
        .then((response) => response.blob())
        .then((blob) => new File([blob], file1, { type: mimetype }))
        .catch((error) => {
          console.error(`Error fetching public file: ${file1}`, error);
          return null;
        }),
    );
  }
  if (file2) {
    files.push(
      fetch(file2)
        .then((response) => response.blob())
        .then((blob) => new File([blob], file2, { type: mimetype }))
        .catch((error) => {
          console.error(`Error fetching public file: ${file2}`, error);
          return null;
        }),
    );
  }

  return Promise.all(files);
}

export function SamepleElements({ handleRunWithSample, sampleFileName1, sampleFileName2 }) {
  return (
    <div>
      <hr />
      Want to test wtih a sample file first?
      <br />
      {sampleFileName1 ? (
        <>
          <Button
            variant="primary"
            type="submit"
            onClick={handleRunWithSample}
            // disabled={}
            className="mt-3 px-4"
          >
            Test with sample file(s)
          </Button>
          <br />
          <a href={`${sampleFileName1}`} target="_blank">
            View Sample File 1
          </a>
          <br />
          {sampleFileName2 && (
            <a href={`${sampleFileName2}`} target="_blank">
              View Sample File 2
            </a>
          )}
        </>
      ) : (
        <p>loading sample files...</p>
      )}
    </div>
  );
}
